"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _FileDetail = _interopRequireDefault(require("FileManagerLib/components/browser/FileDetail"));

var _Folders = require("FileManagerCore/selectors/Folders");

var _Auth = require("FileManagerCore/selectors/Auth");

var _Files = require("FileManagerLib/actions/Files");

var _Actions = require("FileManagerLib/actions/Actions");

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    parentFolder: (0, _Folders.getParentFolderForFile)(state, props),
    folderCount: (0, _Folders.getFoldersCount)(state),
    hasDirectFileLinkAccess: (0, _Auth.getHasDirectFileLinkAccessScope)(state),
    isUngatedForImageOptimization: (0, _Auth.getIsUngatedForImageOptimization)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onDelete: function onDelete(file) {
      dispatch((0, _Files.removeFile)(file));
    },
    onMove: function onMove(file, folder) {
      dispatch((0, _Files.moveFile)(file, folder.get('id')));
    },
    onRename: function onRename(file, newName) {
      dispatch((0, _Files.renameFile)(file, newName));
    },
    onUpdateHeight: function onUpdateHeight(file, height) {
      dispatch((0, _Actions.updateDetailHeight)(file, height));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FileDetail.default);

exports.default = _default;
module.exports = exports.default;